import { objectToQueryString } from '@/common/js/utils';
import { IAddSimCardArgs, IAddSimCardResponse, IDeleteSimCard_QueryArgs, IGetPartnerInfoArgs, IGetPartnerInfoRes, IGetSimCard_BodyArgs, IGetSimCardList_BodyArgs,  ISimCard,  TGetSimCardListRes } from '@reolink-cloud/interface';
import { httpManager as http } from '@/plugins/HttpManager';
import { GetUserDataError } from '@/utils/error';
import { errorUploader } from '@/lib/errorUploader';

export const getSimCardList = async ( args: IGetSimCardList_BodyArgs ): Promise<TGetSimCardListRes> => {

    try {

        const { data } = await http.post<TGetSimCardListRes>( '/devices/sim-cards/items/list-query', args );

        return data;
    
    } catch ( e: unknown ) {

        console.error( e );
        errorUploader.uploadApiError( 'getSimCardList', e );
        throw new GetUserDataError( 'get sim card list fail' );

    }

};

export const getSimCard = async ( args: IGetSimCard_BodyArgs ): Promise<ISimCard> => {

    try {

        const { data } = await http.post<ISimCard>( '/devices/sim-cards/items/query', args );

        return data;
    
    } catch ( e: unknown ) {

        console.error( e );
        throw new GetUserDataError( 'get sim card fail' );
    
    }

};

export const deleteSim = async ( args: IDeleteSimCard_QueryArgs ): Promise<void> => {

    await http.patch( `/devices/sim-cards/bind/status`, args );

};

export const addSim = async ( args: IAddSimCardArgs ): Promise<IAddSimCardResponse> => {

    const { data } = await http.post<IAddSimCardResponse>( '/devices/sim-cards/bind', args );

    return data;

};

export const getPartnerInfo = async ( args: IGetPartnerInfoArgs ): Promise<IGetPartnerInfoRes> => {

    const { data } = await http.get<IGetPartnerInfoRes>( `/shop/partner/info${objectToQueryString( args )}` );

    return data;

};

export const activateSimCard = async ( iccid: string ): Promise<void> => {

    await http.post( '/sim-cards/activate', { iccid });

};
